import { FACTOR_CENTIMETER_MILLIMETER } from '../../../constants';
import { Alignment } from '../../Alignment';
import { Slot, SlotLineChild } from '../../Slot';
import { SlotType } from '../../SlotDefinition';

export class SlotPersistenceMapper {
  public static toDto = (slot: Slot): SimpleProjectServiceAPI.SlotDto => {
    const slotDto: SimpleProjectServiceAPI.SlotDto = {
      id: slot.id,
      type: slot.type,
      parentId: slot.parentId,
      blockedBy: slot.blockedBy,
      name: slot.definition.name,
    };

    if (slot.type === SlotType.SINGLE) {
      slotDto.childId = slot.childId;
      slotDto.xIndex = slot.definition.xIndex;
      slotDto.yIndex = slot.definition.yIndex;
      slotDto.alignment =
        slot.definition.alignment === Alignment.NONE ? null : slot.definition.alignment;
      return slotDto;
    }

    if (slot.type === SlotType.LINE) {
      slotDto.children = slot.children.map(
        (slotLineChild): SimpleProjectServiceAPI.SlotLineChildDto => ({
          id: slotLineChild.id,
          position: slotLineChild.position,
        }),
      );
      slotDto.axis = slot.definition.axis;
      slotDto.length = slot.definition.length * FACTOR_CENTIMETER_MILLIMETER;
      return slotDto;
    }

    slotDto.childId = slot.childId;
    return slotDto;
  };

  public static toDomain = (dto: SimpleProjectServiceAPI.SlotDto): Slot => {
    switch (dto.type) {
      case SlotType.SINGLE:
        return {
          id: dto.id,
          childId: dto.childId,
          parentId: dto.parentId,
          type: SlotType.SINGLE,
          blockedBy: dto.blockedBy,
          definition: {
            name: dto.name,
            alignment: dto.alignment ? (dto.alignment as Alignment) : Alignment.NONE,
            xIndex: dto.xIndex,
            yIndex: dto.yIndex,
            type: SlotType.SINGLE,
          },
        };
      case SlotType.LINE:
        return {
          id: dto.id,
          parentId: dto.parentId,
          type: SlotType.LINE,
          blockedBy: dto.blockedBy,
          children: dto.children.map(
            (slotLineChild): SlotLineChild => ({
              id: slotLineChild.id,
              position: slotLineChild.position,
            }),
          ),
          definition: {
            name: dto.name,
            length: dto.length / FACTOR_CENTIMETER_MILLIMETER,
            axis: dto.axis,
            type: SlotType.LINE,
          },
        };
      case SlotType.PAIR:
        return {
          id: dto.id,
          childId: dto.childId,
          parentId: dto.parentId,
          type: SlotType.PAIR,
          blockedBy: dto.blockedBy,
          definition: {
            name: dto.name,
            type: SlotType.PAIR,
          },
        };
      default:
        throw new Error(`Unknown slot type ${dto.type}`);
    }
  };
}
